/** @format */
import React from "react";
import "../components/MyProfile/Myprofile.css";
import { ImSpinner3 } from "@react-icons/all-files/im/ImSpinner3";

const Loader = () => {
  return <ImSpinner3 className="Loader" />;
};
export default Loader;
